import { weekendsService } from "../../services/api";
import { loadDays } from "./schedule";
import { loadSkills } from "./skills";
import { loadWeekendInfo } from "./weekendInfo";

export interface Weekend {
  id: number;
  name: string;
  slug: string;
  status?: string;
}

let weekendList: Weekend[] = [];

export async function loadWeekends(): Promise<void> {
  try {
    const response = await weekendsService.getAll();
    weekendList = response.data;
  } catch (error) {
    console.error("Failed to load weekends:", error);
    weekendList = [];
  }
}

// Returns the full list so callers can use it directly (e.g. to set React state)
export async function loadAllWeekends(): Promise<Weekend[]> {
  await loadWeekends();

  await Promise.all(
    weekendList.map((weekend) =>
      Promise.all([
        loadWeekendInfo(weekend.id),
        loadSkills(weekend.id),
        loadDays(weekend.id),
      ])
    )
  );

  return weekendList;
}

export function getWeekends(): Weekend[] {
  return structuredClone(weekendList);
}

export function getWeekendById(id: number): Weekend | undefined {
  return weekendList.find((w) => w.id === id);
}

export function getWeekendBySlug(slug: string): Weekend | undefined {
  return weekendList.find((w) => w.slug === slug);
}